import { t, Trans } from '@lingui/macro';
import _ from 'lodash';
import { useFormContext } from 'react-hook-form';
import { MenuItem } from '@material-ui/core';
import FormSection from '../../form/FormSection';
import NgpSelect from '../../form/NgpSelect';
import {
    AGENT_WEB_UI_PASSWORD_VALUE_FIELD,
    AGENT_WEB_UI_SELECTION_ENABLED_CREDS_OPTION,
    AGENT_WEB_UI_SELECTION_ENABLED_OPTION,
    AGENT_WEB_UI_SELECTION_FIELD,
    AGENT_WEB_UI_SELECTION_OPTIONS,
    AGENT_WEB_UI_USERNAME_VALUE_FIELD,
} from './AgentSettingsConstants';
import NgpTextField from '../../form/NgpTextField';
import { AUTO_COMPLETE_DEFAULT } from '../../../utilities/FormUtilities';
import NgpPasswordField from '../../form/NgpPasswordField';
import { useDetailStyles } from './AgentSettingsStyles';
import NgpFieldHelpTip from '../../form/NgpFieldHelpTip';
import { RowFlexLayout } from '../../layout';

export default function AgentWebAccess() {
    const classes = useDetailStyles();
    const { watch } = useFormContext();
    const webUiSelection = watch(AGENT_WEB_UI_SELECTION_FIELD);

    return (
        <FormSection title={<Trans>nPoint Admin Web Access</Trans>}>
            <RowFlexLayout>
                <NgpSelect
                    fieldName={AGENT_WEB_UI_SELECTION_FIELD}
                    label={t`Manage nPoint Admin Web Access`}
                    required
                    className={classes.agentAccessSelection}
                >
                    {_.map(AGENT_WEB_UI_SELECTION_OPTIONS, (value, key) => (
                        <MenuItem key={key} value={key}>
                            {value}
                        </MenuItem>
                    ))}
                </NgpSelect>

                {webUiSelection === AGENT_WEB_UI_SELECTION_ENABLED_OPTION && (
                    <NgpFieldHelpTip
                        helpText={<Trans>The factory default username/password is administrator/netscout1</Trans>}
                    />
                )}
            </RowFlexLayout>

            {webUiSelection === AGENT_WEB_UI_SELECTION_ENABLED_CREDS_OPTION && (
                <>
                    <NgpTextField
                        fieldName={AGENT_WEB_UI_USERNAME_VALUE_FIELD}
                        label={<Trans>Username</Trans>}
                        required
                        inputProps={{
                            size: 60,
                            maxLength: 2083,
                            autoComplete: AUTO_COMPLETE_DEFAULT,
                        }}
                    />

                    <NgpPasswordField
                        fieldName={AGENT_WEB_UI_PASSWORD_VALUE_FIELD}
                        label={<Trans>Password</Trans>}
                        inputProps={{ size: 60, maxLength: 2083 }}
                        required
                        togglePasswordVisibility
                    />
                </>
            )}
        </FormSection>
    );
}
